import type { TFunction } from 'i18next';

import type { GamesCopy } from './games-summary';

/**
 * The Game Lists card's copy: one literal `t()` key per id, so the extractor harvests every one; the `switch` is
 * exhaustive, so a new id fails the typecheck until it has its copy. Either count can be one, so each has its singular
 * (the hidden ones never outnumber the lists, so a single list hidden is the only case of one of each).
 */
export const gamesCopy = (t: TFunction, c: GamesCopy): string => {
  switch (c.id) {
    case 'unpublished-changes':
      return t('Unpublished changes');
    case 'lists-on-homepage':
      return c.n === 1 ? t('1 list on your Homepage') : t('{{n}} lists on your Homepage', { n: c.n });
    case 'lists-on-homepage-hidden':
      if (c.n === 1) return t('1 list on your Homepage, hidden');
      return c.m === 1
        ? t('{{n}} lists on your Homepage, 1 hidden', { n: c.n })
        : t('{{n}} lists on your Homepage, {{m}} hidden', { n: c.n, m: c.m });
    case 'review-and-publish':
      return t('Review and publish');
    case 'open-game-lists':
      return t('Open game lists');
  }
};
